"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLevelParagraphWidowOrphanControlHistoryItem = exports.ListLevelParagraphSuppressLineNumbersHistoryItem = exports.ListLevelParagraphSuppressHyphenationHistoryItem = exports.ListLevelParagraphSpacingBeforeHistoryItem = exports.ListLevelParagraphSpacingAfterHistoryItem = exports.ListLevelParagraphRightIndentHistoryItem = exports.ListLevelParagraphPageBreakBeforeHistoryItem = exports.ListLevelParagraphOutlineLevelHistoryItem = exports.ListLevelParagraphLineSpacingTypeHistoryItem = exports.ListLevelParagraphLineSpacingHistoryItem = exports.ListLevelParagraphLeftIndentHistoryItem = exports.ListLevelParagraphKeepLinesTogetherHistoryItem = exports.ListLevelParagraphFirstLineIndentTypeHistoryItem = exports.ListLevelParagraphFirstLineIndentHistoryItem = exports.ListLevelParagraphBeforeAutoSpacingHistoryItem = exports.ListLevelParagraphShadingInfoHistoryItem = exports.ListLevelParagraphAfterAutoSpacingHistoryItem = exports.ListLevelParagraphContextualSpacingHistoryItem = exports.ListLevelParagraphAlignmentHistoryItem = exports.ListLevelParagraphPropertiesHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var history_item_1 = require("../base/history-item");
var ListLevelParagraphPropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(ListLevelParagraphPropertiesHistoryItemBase, _super);
    function ListLevelParagraphPropertiesHistoryItemBase(modelManipulator, isAbstractList, listIndex, levelIndex, newValue, newUse) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.newValue = newValue;
        _this.isAbstractList = isAbstractList;
        _this.listIndex = listIndex;
        _this.levelIndex = levelIndex;
        _this.newUse = newUse;
        return _this;
    }
    ListLevelParagraphPropertiesHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getManipulator().setValue(this.modelManipulator.model, this.isAbstractList, this.listIndex, this.levelIndex, this.newValue, this.newUse);
    };
    ListLevelParagraphPropertiesHistoryItemBase.prototype.undo = function () {
        this.getManipulator().restoreValue(this.modelManipulator.model, this.oldState);
    };
    ListLevelParagraphPropertiesHistoryItemBase.prototype.getManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return ListLevelParagraphPropertiesHistoryItemBase;
}(history_item_1.HistoryItem));
exports.ListLevelParagraphPropertiesHistoryItemBase = ListLevelParagraphPropertiesHistoryItemBase;
var ListLevelParagraphAlignmentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphAlignmentHistoryItem, _super);
    function ListLevelParagraphAlignmentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphAlignmentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.align;
    };
    return ListLevelParagraphAlignmentHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphAlignmentHistoryItem = ListLevelParagraphAlignmentHistoryItem;
var ListLevelParagraphContextualSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphContextualSpacingHistoryItem, _super);
    function ListLevelParagraphContextualSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphContextualSpacingHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.contextualSpacing;
    };
    return ListLevelParagraphContextualSpacingHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphContextualSpacingHistoryItem = ListLevelParagraphContextualSpacingHistoryItem;
var ListLevelParagraphAfterAutoSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphAfterAutoSpacingHistoryItem, _super);
    function ListLevelParagraphAfterAutoSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphAfterAutoSpacingHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.afterAutoSpacing;
    };
    return ListLevelParagraphAfterAutoSpacingHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphAfterAutoSpacingHistoryItem = ListLevelParagraphAfterAutoSpacingHistoryItem;
var ListLevelParagraphShadingInfoHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphShadingInfoHistoryItem, _super);
    function ListLevelParagraphShadingInfoHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphShadingInfoHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.shadingInfo;
    };
    return ListLevelParagraphShadingInfoHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphShadingInfoHistoryItem = ListLevelParagraphShadingInfoHistoryItem;
var ListLevelParagraphBeforeAutoSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphBeforeAutoSpacingHistoryItem, _super);
    function ListLevelParagraphBeforeAutoSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphBeforeAutoSpacingHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.beforeAutoSpacing;
    };
    return ListLevelParagraphBeforeAutoSpacingHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphBeforeAutoSpacingHistoryItem = ListLevelParagraphBeforeAutoSpacingHistoryItem;
var ListLevelParagraphFirstLineIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphFirstLineIndentHistoryItem, _super);
    function ListLevelParagraphFirstLineIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphFirstLineIndentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.firstLineIndent;
    };
    return ListLevelParagraphFirstLineIndentHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphFirstLineIndentHistoryItem = ListLevelParagraphFirstLineIndentHistoryItem;
var ListLevelParagraphFirstLineIndentTypeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphFirstLineIndentTypeHistoryItem, _super);
    function ListLevelParagraphFirstLineIndentTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphFirstLineIndentTypeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.firstLineIndentType;
    };
    return ListLevelParagraphFirstLineIndentTypeHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphFirstLineIndentTypeHistoryItem = ListLevelParagraphFirstLineIndentTypeHistoryItem;
var ListLevelParagraphKeepLinesTogetherHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphKeepLinesTogetherHistoryItem, _super);
    function ListLevelParagraphKeepLinesTogetherHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphKeepLinesTogetherHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.keepLinesTogether;
    };
    return ListLevelParagraphKeepLinesTogetherHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphKeepLinesTogetherHistoryItem = ListLevelParagraphKeepLinesTogetherHistoryItem;
var ListLevelParagraphLeftIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphLeftIndentHistoryItem, _super);
    function ListLevelParagraphLeftIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphLeftIndentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.leftIndent;
    };
    return ListLevelParagraphLeftIndentHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphLeftIndentHistoryItem = ListLevelParagraphLeftIndentHistoryItem;
var ListLevelParagraphLineSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphLineSpacingHistoryItem, _super);
    function ListLevelParagraphLineSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphLineSpacingHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.lineSpacing;
    };
    return ListLevelParagraphLineSpacingHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphLineSpacingHistoryItem = ListLevelParagraphLineSpacingHistoryItem;
var ListLevelParagraphLineSpacingTypeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphLineSpacingTypeHistoryItem, _super);
    function ListLevelParagraphLineSpacingTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphLineSpacingTypeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.lineSpacingType;
    };
    return ListLevelParagraphLineSpacingTypeHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphLineSpacingTypeHistoryItem = ListLevelParagraphLineSpacingTypeHistoryItem;
var ListLevelParagraphOutlineLevelHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphOutlineLevelHistoryItem, _super);
    function ListLevelParagraphOutlineLevelHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphOutlineLevelHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.outlineLevel;
    };
    return ListLevelParagraphOutlineLevelHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphOutlineLevelHistoryItem = ListLevelParagraphOutlineLevelHistoryItem;
var ListLevelParagraphPageBreakBeforeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphPageBreakBeforeHistoryItem, _super);
    function ListLevelParagraphPageBreakBeforeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphPageBreakBeforeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.pageBreakBefore;
    };
    return ListLevelParagraphPageBreakBeforeHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphPageBreakBeforeHistoryItem = ListLevelParagraphPageBreakBeforeHistoryItem;
var ListLevelParagraphRightIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphRightIndentHistoryItem, _super);
    function ListLevelParagraphRightIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphRightIndentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.rightIndent;
    };
    return ListLevelParagraphRightIndentHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphRightIndentHistoryItem = ListLevelParagraphRightIndentHistoryItem;
var ListLevelParagraphSpacingAfterHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphSpacingAfterHistoryItem, _super);
    function ListLevelParagraphSpacingAfterHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphSpacingAfterHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.spacingAfter;
    };
    return ListLevelParagraphSpacingAfterHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphSpacingAfterHistoryItem = ListLevelParagraphSpacingAfterHistoryItem;
var ListLevelParagraphSpacingBeforeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphSpacingBeforeHistoryItem, _super);
    function ListLevelParagraphSpacingBeforeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphSpacingBeforeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.spacingBefore;
    };
    return ListLevelParagraphSpacingBeforeHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphSpacingBeforeHistoryItem = ListLevelParagraphSpacingBeforeHistoryItem;
var ListLevelParagraphSuppressHyphenationHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphSuppressHyphenationHistoryItem, _super);
    function ListLevelParagraphSuppressHyphenationHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphSuppressHyphenationHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.suppressHyphenation;
    };
    return ListLevelParagraphSuppressHyphenationHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphSuppressHyphenationHistoryItem = ListLevelParagraphSuppressHyphenationHistoryItem;
var ListLevelParagraphSuppressLineNumbersHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphSuppressLineNumbersHistoryItem, _super);
    function ListLevelParagraphSuppressLineNumbersHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphSuppressLineNumbersHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.suppressLineNumbers;
    };
    return ListLevelParagraphSuppressLineNumbersHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphSuppressLineNumbersHistoryItem = ListLevelParagraphSuppressLineNumbersHistoryItem;
var ListLevelParagraphWidowOrphanControlHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelParagraphWidowOrphanControlHistoryItem, _super);
    function ListLevelParagraphWidowOrphanControlHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelParagraphWidowOrphanControlHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelParagraphProperties.widowOrphanControl;
    };
    return ListLevelParagraphWidowOrphanControlHistoryItem;
}(ListLevelParagraphPropertiesHistoryItemBase));
exports.ListLevelParagraphWidowOrphanControlHistoryItem = ListLevelParagraphWidowOrphanControlHistoryItem;
